import React from 'react'
import { createRoot } from 'react-dom/client'
import { initSentry } from '@/lib/sentry'
import EditorApp from '@/editor/EditorApp'

initSentry()

function MobileBlocker() {
  return (
    <div className="flex h-screen flex-col items-center justify-center bg-[#f6f6f8] px-8 text-center">
      <img src="/illustrations/desktop-required.svg" alt="" className="w-40 h-auto mb-8" />
      <h1 className="text-2xl font-bold text-slate-900 mb-2">Desktop Required</h1>
      <p className="text-slate-500 max-w-sm leading-relaxed">
        The Explaina editor is designed for desktop screens. Open this page on a computer to create and edit your demos.
      </p>
      <a href="/" className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-primary hover:underline">
        <span className="material-symbols-outlined text-base">arrow_back</span>
        Back to home
      </a>
    </div>
  )
}

const container = document.getElementById('editor-root')
if (container) {
  const demoId = container.dataset.demoId
  const userPlan = (container.dataset.userPlan || 'free') as 'free' | 'pro' | 'enterprise'
  const isGuest = container.dataset.guest === 'true'
  const isMobile = window.innerWidth < 768
  const root = createRoot(container)
  root.render(isMobile ? <MobileBlocker /> : <EditorApp demoId={demoId} userPlan={userPlan} isGuest={isGuest} />)
}
